/**
 * Team MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import { TEAM_SETTINGS_QUERY_KEY, fetchTeamSettingsFromApi } from "./teamQueryApi";

export const teamQueryClient = makeMv2QueryClient();
setupMv2CachePersist(teamQueryClient, "team");

export function prefetchTeam() {
  return teamQueryClient.prefetchQuery({
    queryKey: [TEAM_SETTINGS_QUERY_KEY],
    queryFn: ({ signal }) => fetchTeamSettingsFromApi(signal),
  });
}
